import axios from "axios";

const URL_DICTIONARIES = import.meta.env.VITE_AUTH_DICTIONARIES;

export function DepartmentListByCountryService(token, countryId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${URL_DICTIONARIES}/api/locations/v1/departments/list/country/${countryId}`,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });
}